import z from "zod";

const locales = [
  "ar",
  "da",
  "de",
  "en",
  "es",
  "fi",
  "fr",
  "id",
  "it",
  "ja",
  "ko",
  "ms",
  "nl",
  "pl",
  "pt",
  "ru",
  "th",
  "tr",
  "vi",
  "zh", // Traditional Chinese
  "zh-hans", // Simplified Chinese
] as const;

export const LocaleSchema = z.enum(locales);

export const Locale = LocaleSchema;
export type Locale = z.infer<typeof LocaleSchema>;

export const DefaultLocale: Locale = "en";

export type ExtraLocaleData = {
  name: string;
};

export const LocaleDataMapping: Record<Locale, ExtraLocaleData> = {
  en: {
    name: "English",
  },
  fr: {
    name: "French",
  },
  es: {
    name: "Spanish",
  },
  de: {
    name: "German",
  },
  id: {
    name: "Indonesian",
  },
  it: {
    name: "Italian",
  },
  ja: {
    name: "Japanese",
  },
  ko: {
    name: "Korean",
  },
  pl: {
    name: "Polish",
  },
  pt: {
    name: "Portuguese",
  },
  ru: {
    name: "Russian",
  },
  tr: {
    name: "Turkish",
  },
  ar: {
    name: "Arabic",
  },
  zh: {
    name: "Traditional Chinese",
  },
  "zh-hans": {
    name: "Simplified Chinese",
  },
  da: {
    name: "Danish",
  },
  nl: {
    name: "Dutch",
  },
  fi: {
    name: "Finnish",
  },
  ms: {
    name: "Malaysian",
  },
  th: {
    name: "Thai",
  },
  vi: {
    name: "Vietnamese",
  },
};

export const LocaleLabels = Object.fromEntries(
  locales.map((locale) => [locale, LocaleDataMapping[locale].name]),
) as Record<Locale, string>;
